import moment from 'moment';

import { removeThousandSeparatorMask } from '../../../../helpers/formatador';

const fieldsRequired = [
  'cadencia',
  'cidadeDestino',
  'cidadeOrigem',
  'cnpjClientePagador',
  'dataInicio',
  'especie',
  'produto',
  'volume',
];

const validarDados = (dados, field, fieldValue) =>
  dados?.some(dado => dado[field] === fieldValue);

export const validarCidadesOrigemDestino = (
  idCidadesOrigemDestino,
  idCidades
) =>
  idCidadesOrigemDestino.some(
    cidades =>
      cidades.idCidadeOrigem === idCidades.idCidadeOrigem &&
      cidades.idCidadeDestino === idCidades.idCidadeDestino
  );

export const validarCidadeOrigemDestino = (idCidadesOrigemDestino, idCidades) =>
  idCidades.idCidadeOrigem === null ||
  idCidades.idCidadeDestino === null ||
  (idCidades.idCidadeOrigem === idCidadesOrigemDestino?.idCidadeOrigem &&
    idCidades.idCidadeDestino === idCidadesOrigemDestino?.idCidadeDestino);

export const validateLoteIntegracao = loteIntegracao => {
  fieldsRequired.forEach(field => {
    if (!loteIntegracao[field]) {
      loteIntegracao.errors[field] = 'O campo é obrigatório';
    }
  });

  if (
    validarDados(
      loteIntegracao.dataPagadores,
      'cnpj',
      loteIntegracao.cnpjClientePagador
    ) &&
    loteIntegracao.cnpjClientePagador &&
    loteIntegracao.errors.cnpjClientePagador
  ) {
    delete loteIntegracao.errors.cnpjClientePagador;
  }

  if (
    validarDados(
      loteIntegracao.dataClienteColeta,
      'cnpj',
      loteIntegracao.cnpjClienteColeta
    ) &&
    loteIntegracao.cnpjClienteColeta &&
    loteIntegracao.errors.clienteColeta
  ) {
    delete loteIntegracao.errors.clienteColeta;
  }

  if (
    validarDados(
      loteIntegracao.dataProdutos,
      'descricaoProduto',
      loteIntegracao.produto
    ) &&
    loteIntegracao.produto &&
    loteIntegracao.errors.produto
  ) {
    delete loteIntegracao.errors.produto;
  }

  if (
    validarDados(
      loteIntegracao.dataEspecies,
      'descricaoEspecie',
      loteIntegracao.especie
    ) &&
    loteIntegracao.especie &&
    loteIntegracao.errors.especie
  ) {
    delete loteIntegracao.errors.especie;
  }

  if (
    validarDados(
      loteIntegracao.cidadeOrigemData,
      'idCidade',
      loteIntegracao.idCidadeOrigem
    ) &&
    loteIntegracao.idCidadeOrigem &&
    loteIntegracao.errors.cidadeOrigem
  ) {
    delete loteIntegracao.errors.cidadeOrigem;
  }

  if (
    validarDados(
      loteIntegracao.cidadeDestinoData,
      'idCidade',
      loteIntegracao.idCidadeDestino
    ) &&
    loteIntegracao.idCidadeDestino &&
    loteIntegracao.errors.cidadeDestino
  ) {
    delete loteIntegracao.errors.cidadeDestino;
  }

  if (
    (validarDados(
      loteIntegracao.cidadeColetaData,
      'idCidade',
      loteIntegracao.idCidadeColeta
    ) ||
      !loteIntegracao.cidadeColeta) &&
    loteIntegracao.errors.cidadeColeta
  ) {
    delete loteIntegracao.errors.cidadeColeta;
  }

  if (
    (validarDados(
      loteIntegracao.cidadeEntregaData,
      'idCidade',
      loteIntegracao.idCidadeEntrega
    ) ||
      !loteIntegracao.cidadeEntrega) &&
    loteIntegracao.errors.cidadeEntrega
  ) {
    delete loteIntegracao.errors.cidadeEntrega;
  }

  if (loteIntegracao.volume && loteIntegracao.errors.volume) {
    delete loteIntegracao.errors.volume;
  }

  if (loteIntegracao.cadencia && loteIntegracao.errors.cadencia) {
    delete loteIntegracao.errors.cadencia;
  }

  const cadencia =
    loteIntegracao.cadencia &&
    removeThousandSeparatorMask(loteIntegracao.cadencia);
  const volume =
    loteIntegracao.volume && removeThousandSeparatorMask(loteIntegracao.volume);
  if (cadencia > volume) {
    loteIntegracao.errors.cadencia =
      'A cadência não pode ser maior que o volume';
  }

  if (
    (loteIntegracao.freteMotoristaPj || loteIntegracao.freteMotoristaPf) &&
    loteIntegracao.errors.frete
  ) {
    delete loteIntegracao.errors.frete;
  }

  if (loteIntegracao.dataInicio || loteIntegracao.dataFim) {
    const { dataInicio, dataFim } = loteIntegracao;

    if (
      loteIntegracao.errors.dataInicio &&
      moment(dataInicio).isSameOrAfter(moment(), 'day')
    ) {
      delete loteIntegracao.errors.dataInicio;
    }

    if (dataFim && moment(dataInicio).isAfter(dataFim, 'day')) {
      loteIntegracao.errors.dataFim =
        'A data final deve ser maior que a data de início';
    }

    if (
      loteIntegracao.errors.dataFim &&
      (!dataFim || moment(dataFim).isSameOrAfter(dataInicio, 'day'))
    ) {
      delete loteIntegracao.errors.dataFim;
    }
  }

  return loteIntegracao;
};
